import * as React from 'react';
import { cn } from '@common/bw-ui/lib/utils';
import { useApp } from '@bw-ui/hooks/useApp';
import { routes } from '@portal/env/routes';
import Link from 'next/link';

export interface CheckoutFlowHeaderProps {
  className?: string;
  children?: React.ReactNode;
}

export function CheckoutFlowHeader({
  className,
  children,
}: CheckoutFlowHeaderProps) {
  const { logoUrl, businessName } = useApp();
  return (
    <header>
      <div
        data-slot="checkout-flow-header"
        className={cn(
          'tw:bg-nav-bg tw:h-16 tw:px-6 tw:flex tw:items-center',
          className,
        )}
      >
        {logoUrl && (
          <Link href={routes.home}>
            <img
              src={logoUrl}
              alt={businessName}
              className="tw:max-w-48 tw:max-h-6 tw:brightness-0 tw:invert"
            />
          </Link>
        )}
      </div>
      {children}
    </header>
  );
}
